import { CSSProperties } from 'react'
import { cn } from '@wellesley/ui'
import { ITEM_WIDTH, SIDEBAR_SPACE_WIDTH } from '.'
import { useSelector } from 'react-redux'
import { selectIsSideBarSticky } from './slice'

const PHANTOM_OFFSET = 10
export const SideBarPhantom = () => {
  const isSideBarSticky = useSelector(selectIsSideBarSticky)

  return (
    <div
      className={cn(
        'ml-[--SIDEBAR_SPACE_WIDTH] mr-s w-0 min-w-0  transition-[min-width,width] duration-300 ease-in-out',
        { [ITEM_WIDTH]: isSideBarSticky },
      )}
      style={
        {
          '--SIDEBAR_SPACE_WIDTH': `${isSideBarSticky ? SIDEBAR_SPACE_WIDTH - PHANTOM_OFFSET : 0}px`,
        } as CSSProperties
      }
    />
  )
}
